<template>
	<!-- 我的 -->
	<div class="all_main">
		<div class="backgroundC_main" style="height: 6rem;padding: 1rem 1rem;position: relative;" @click="toUserInfo()">
			<div class="all_height20" style="display: flex;">
				<span class="text16 all_line_height20 textcolorwhite font_weight_900 display_inline_block"
					style="width: 30%;">{{$store.state.userInfo.staffName}}</span>
				<span class="text10 all_height_line12 all_text_center" @click.stop="toAuth()"
					style="width: 20%;display: flex;background-color: #f0faf2;border-radius: .2rem;margin: .4rem 0;"
					:class="{'passed':$store.state.userInfo.certifyWay!=0,'nopassed':$store.state.userInfo.certifyWay===0}">
					{{$store.state.userInfo.certifyWay!=0?'已认证':'未认证'}}</span>
			</div>
			<div class="text14 textcolorwhite all_line_height14">
				{{$store.state.userInfo.mobile?$store.state.userInfo.mobile.replace(/^(\d{3})\d+(\d{4})$/,"$1****$2"):''}}
			</div>
			<img style="position: absolute; top: 3rem;right:1.3rem;width: 1.4rem,height:1.4rem;"
				src="@/assets/images/u359.png" />
		</div>
		<div class="margin_top_10 backgroundC_white">
			<div class="all_height_line24 backgroundC_white display_flex bwhite_ative" @click="certClick()">
				<span class="text14 textcolor333 all_line_height24 display_inline_block"
					style="width: 90%;padding-left: .8rem;">证书管理</span>
				<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
			</div>
			<div class="all_height_line24 backgroundC_white display_flex bwhite_ative" @click="settingsClick()">
				<span class="text14 textcolor333 all_line_height24 display_inline_block"
					style="width: 90%;padding-left: .8rem;">设置</span>
				<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	export default {
		name: 'zhlhUser',
		components: {
		},
		data() {
			return {
				//姓名
				staffName: '',
				//手机号
				mobile: '',
			};
		},
		methods: {
			//个人信息页面
			toUserInfo() {
				this.$router.push({
					path: '/userinfo',
				});
			},
			//个人认证
			// toAuth() {
			// 	if (this.$store.state.userInfo.certifyWay === 0) {
			// 		this.$router.push({
			// 			path: 'personalauthflow',
			// 		});
			// 	}
			// },
			//获取个人信息
			getUserInfo() {
				if (!this.$store.state.userInfo) {
					this.$store.dispatch(this.$LoadShow, true)
					this.$post("/my/api/getDetailForMobile")
						.then((res) => {
							this.$store.dispatch(this.$LoadShow, false)
							if (res.success && res.data) {
								this.$store.dispatch("actionUserInfo", res.data);
								// this.moblie = this.$store.state.userInfo.mobile.replace(/^(\d{3})\d+(\d{4})$/,
								// 	"$1****$2")
								//this.staffName = this.$store.state.userInfo.staffName
							} else {
								//this.$Toast('请重新进入')
							}
						});
				} else {
					//this.staffName = this.$store.state.userInfo.staffName
					// this.moblie = this.$store.state.userInfo.mobile.replace(/^(\d{3})\d+(\d{4})$/,
					// 	"$1****$2")
				}
			},
			//证书管理
			certClick() {
				if(this.$store.state.userInfo.certifyWay === 0){
					this.$Toast('请先在网页上进行个人认证!')
					return
				}
				this.$router.push({
					path: '/certlist',
				});
			},
			//设置
			settingsClick() {
				this.$router.push({
					path: '/settings',
				});
			},
		},
		mounted() {
			this.getUserInfo()
		},
	};
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	.right {
		position: absolute;
		top: 1.8rem;
		right: .5rem;
		z-index: 10;
	}

	.passed {
		color: #66BE74;
		border: 1px solid #66BE74;
	}

	.passed::before {
		content: url('../../assets/images/personal_auth.svg');
		display: inline-block;
		width: .8rem;
		height: .8rem;
		margin-right: .3rem;
		transform: scale(0.5);
	}

	.nopassed {
		color: #DF4545;
		border: 1px solid #DF4545;
		justify-content: center;
	}

	.item {
		float: right;
	}

	.item::after {
		content: url('../../assets/images/u359.png');
		display: inline-block;
		width: .7rem;
		height: 1.4rem;
		line-height: 1.4rem;
		// margin: 0 .5rem;
	}
</style>